import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, Radio, Users, Eye, ChevronRight } from "lucide-react";
import api from "../../lib/api";

/* Travel Guardian card inside My Travel Hub. */
export default function GuardianSection() {
  const [ov, setOv] = useState(null);
  useEffect(() => { api.get("/guardian/overview").then((r) => setOv(r.data)).catch(() => setOv({})); }, []);
  const sharing = (ov?.active_sessions || 0) > 0;
  return (
    <section data-testid="hub-guardian-section">
      <div className="flex items-center gap-2 mb-3">
        <ShieldCheck className="w-5 h-5 text-emerald-600" />
        <h2 className="font-heading font-900 text-xl">Travel Guardian</h2>
        {sharing && <span className="inline-flex items-center gap-1 bg-emerald-100 text-emerald-800 border border-emerald-300 rounded-full px-2 py-0.5 text-[10px] font-800 uppercase animate-pulse" data-testid="hub-guardian-sharing-badge"><Radio className="w-3 h-3" /> Sharing active</span>}
      </div>
      <div className="border border-emerald-200 bg-gradient-to-r from-emerald-50 to-teal-50 rounded-2xl p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex-1">
          <p className="text-sm font-700 text-zinc-800">Travel freely. Keep the people you trust informed.</p>
          <p className="text-xs text-zinc-600 mt-1">Consent-based location & journey sharing — voluntary, time-limited, revocable, always in your control.</p>
          {ov && (
            <div className="mt-3 flex flex-wrap gap-4 text-xs text-zinc-700">
              <span className="inline-flex items-center gap-1"><Radio className="w-3.5 h-3.5 text-emerald-600" /> <b>{ov.active_sessions || 0}</b> active session{(ov.active_sessions || 0) !== 1 && "s"}</span>
              <span className="inline-flex items-center gap-1"><Users className="w-3.5 h-3.5 text-blue-600" /> <b>{ov.circles || 0}</b> circle{(ov.circles || 0) !== 1 && "s"}</span>
              <span className="inline-flex items-center gap-1"><Eye className="w-3.5 h-3.5 text-violet-600" /> <b>{ov.views_last_24h || 0}</b> views of you (24h)</span>
            </div>
          )}
        </div>
        <Link to="/guardian" data-testid="hub-guardian-open" className="shrink-0 inline-flex items-center gap-1.5 bg-emerald-600 text-white text-sm font-800 rounded-full px-5 py-2.5 hover:bg-emerald-700">
          Open Travel Guardian <ChevronRight className="w-4 h-4" />
        </Link>
      </div>
    </section>
  );
}
